import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { LoggingDB } from 'src/app/common/repository/databases';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { LogEntryDto } from 'src/app/shared/models/logging/log-entry-dto.model';

import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class LoggingWorkItem extends WorkItem<LogEntryDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'LoggingWorkItem';
  }
  get database(): string {
    return LoggingDB;
  }
}
